import { useState } from 'react';
import { CasButton } from 'src/compass/shared/components';
import useRetrieve from 'src/compass/shared/hooks/reactQuery/useRetrieve';
import useCasBoolean from 'src/compass/shared/hooks/useCasBoolean';

import ClaimListing, { ClaimColumns, ClaimFilters, ClaimStatus } from '../../shared/ClaimListing/ClaimListing';
import ReviewedMultiSceClaimsDialog, {
  REVIEWED_MULTI_SCE_URL,
} from '../../shared/ClaimDetails/ReviewedMultiSceClaimsDialog';

import UnbatchedAttachedDialog from './UnbatchedAttachedDialog';

export default function DocusignReviewTab() {
  const dialog = useCasBoolean();
  const reviewedDialog = useCasBoolean();
  const [reloadList, setReloadList] = useState<Date | null>(null);

  // Reviewed SCEs leave this list, so the count says where they went.
  const { data: reviewedClaims, refetch: refetchReviewed } = useRetrieve({
    url: REVIEWED_MULTI_SCE_URL,
  });
  const reviewedCount: number = (reviewedClaims ?? []).reduce(
    (sum: number, claim: any) => sum + claim.reviewedCount,
    0
  );

  return (
    <>
      <ClaimListing
        columns={[
          ClaimColumns.insuredName,
          ClaimColumns.reinsuranceYear,
          ClaimColumns.policyNumber,
          ClaimColumns.sce,
          ClaimColumns.whatSent,
          ClaimColumns.claimNumber,
        ]}
        filters={[ClaimFilters.insuredNameSearch]}
        additionalPayload={{
          status: ClaimStatus.DocusignReview,
        }}
        toolbarButtons={[
          <CasButton key="hudson-email" onClick={dialog.setTrue}>
            Hudson Email Batch
          </CasButton>,
        ]}
        belowToolbar={
          reviewedCount > 0 && (
            <CasButton color="secondary" onClick={reviewedDialog.setTrue} sx={{ mb: 1 }}>
              {reviewedCount} reviewed SCEs are waiting
            </CasButton>
          )
        }
        // Every reload follows a possible Reviewed / Back in Claim Details.
        setData={() => refetchReviewed()}
        update={reloadList}
        linkSharedClaimNumber
        columnsSortable={false}
        includeExport={false}
      />
      {dialog.value && <UnbatchedAttachedDialog onClose={dialog.setFalse} />}
      {reviewedDialog.value && (
        <ReviewedMultiSceClaimsDialog
          onClose={() => {
            reviewedDialog.setFalse();
            refetchReviewed();
            // Back from Reviewed puts an SCE back on this list.
            setReloadList(new Date());
          }}
        />
      )}
    </>
  );
}
